import * as React from 'react';
import { useFormik } from 'formik';
// import * as Yup from 'yup';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import EmailForm from './EmailForm';
import CloseIcon from "@mui/icons-material/Close";
import { Chip, IconButton } from '@material-ui/core';
import { useEffect, useState } from "react";
import { fetchData, mutateData } from '../Service/graphQlService';
import { GET_CONTACTS_TEAM_FOR_RECEIPENTS } from '../Graphql/ContactsQueries/contactsQuery';
import { GET_EMAIL_TEMPLATES, SEND_EMAIL_TO_MEMBER } from '../Graphql/MailQueries/MailQueries';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  FormHelperText,
  Alert,
  TextField
} from '@mui/material';
import ClearIcon from "@mui/icons-material/Clear";
import ReusableSpinner from './ReusableSpinner';
import arrow from "../../svgs/Arrow.svg";
import close from '../../svgs/X.svg';
import removeCircle from '../../svgs/removeCircle.svg';
require('../Dropdown/Dropdown.scss')
import { Autocomplete } from '@material-ui/lab';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

export default function EmailPopover({openEmailPopup, setOpenEmailPopup}) {
  const [templateOptions, setTemplateOptions] = useState([]);
  const [receipentOptions, setReceipentOptions] = useState([]);
  const [message,setMessage]=useState("");
  const [error,setError] = useState(false);
  const [isLoading,setIsLoading] = useState(false);
  // Define validation schema
  // const validationSchema = Yup.object({
  //   recipientName: Yup.array()
  //     .min(1, "At least one recipient is required")
  //     .required("Recipients are required"),
  //   templateName: Yup.string().required("Template is required"),
  // });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      recipientName: [],
      templateName: "",
    },
    // validationSchema,
    // onSubmit: (values) => {
    //   setIsLoading(true);
    //    let recipients = values.recipientName.map(String);
    //   const recipientsEmails = receipentOptions
    //     .filter(option => values.recipientName.includes(option.recipient_id) && option.user_type.toLowerCase() === "user")
    //     .map(option => option.email);
    //   const groups = receipentOptions
    //     .filter(option => values.recipientName.includes(option.recipient_id) && option.user_type.toLowerCase() === "group")
    //     .map(option => option.name);
    //     setMessage("");
    //     setError(false);
    //     let payload = {
    //       id: window.location.pathname.split("/")[2].toString(),
    //       templateName: values.templateName,
    //       recipients: recipients,
    //       recipientsEmails: recipientsEmails,
    //       groups:groups
    //     };

    //   // Add your API call or other processing here
    //   mutateData(SEND_EMAIL_TO_MEMBER,{input:payload})
    //   .then((res)=>{
    //     setIsLoading(false);
    //     if(res.data.sendEmailToMember.success){
    //       setMessage(res.data.sendEmailToMember.message);
    //       setError(false);
    //       setTimeout(() => {
    //         setMessage("");
    //         setOpenEmailPopup(false);
    //         setTemplateOptions([]);
    //         setReceipentOptions([]);
    //       }, 5000);
    //     }
    //     else{
    //       setError(true);
    //       setMessage(res.data.sendEmailToMember.message);
    //     }
    //   })
    // },
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
                let recipients = values.recipientName.map(String);
        const recipientsEmails = receipentOptions
          .filter(option => values.recipientName.includes(option.recipient_id) && option.user_type.toLowerCase() === "user")
          .map(option => option.email);
        const groups = receipentOptions
          .filter(option => values.recipientName.includes(option.recipient_id) && option.user_type.toLowerCase() === "group")
          .map(option => option.name);
        setMessage("");
        setError(false);
        let payload = {
          id: window.location.pathname.split("/")[2].toString(),
          templateName: values.templateName,
          recipients,
          recipientsEmails,
          groups
        };
               const res = await mutateData(SEND_EMAIL_TO_MEMBER, { input: payload });
    
        if(res.data.sendEmailToMember.success){
          setIsLoading(false);
          setMessage(res.data.sendEmailToMember.message);
          setError(false);
          setTimeout(() => {
            setMessage("");
            setOpenEmailPopup(false);
            setTemplateOptions([]);
            setReceipentOptions([]);
          }, 5000);
        } else {
          setError(true);
          setMessage(res.data.sendEmailToMember.message);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error sending email:", error);
        setError(true);
        setMessage(error.message);
        setIsLoading(false);
      } 
    },
  });

  useEffect(() => {
    // Fetch template options
    setIsLoading(true);
    const type = window.location.pathname.split("/")[1] === "teamMember" ? "team" : window.location.pathname.split("/")[1];
    fetchData(GET_EMAIL_TEMPLATES,{type:type})
      .then((res) => {
        if (res && res.data && res.data.getAllEmailTemplates && res.data.getAllEmailTemplates.length > 0) {
          setTemplateOptions(res.data.getAllEmailTemplates);
        } else {
          setMessage(`No templates available for type: "${type.charAt(0).toUpperCase() + type.slice(1)}"`);
          setError(true);
          setTemplateOptions([]);
        }
      })
      .catch((error) => {
        setTemplateOptions([]);
        console.log(error.message);
      });
    const sortOptions = [
      {
        "field": "first_name",
        "order": "asc"
      },
      {
        "field": "last_name",
        "order": "asc"
      }
    ]
    // Fetch recipient options
    // fetchData(GET_CONTACTS_TEAM_FOR_RECEIPENTS, {type: "Team",displayEmailMergeUsers: true,sortOptions:sortOptions})
    //   .then((res) => {
    //     if (res && res.data && res.data.getContacts && res.data.getContacts.data) {
    //       const filterdReceipents = res.data.getContacts.data ;
    //       setReceipentOptions(filterdReceipents);
    //       setIsLoading(false);
    //     } else {
    //       setIsLoading(false);
    //       setReceipentOptions([]);
    //     }
    //   })
    //   .catch((error) => {
    //     setReceipentOptions([]);
    //     console.log(error.message);
    //     setIsLoading(false);
    //   });
    const fetchContacts = async () => {
      setIsLoading(true);
      try {
        const res = await fetchData(GET_CONTACTS_TEAM_FOR_RECEIPENTS);
    
        if (res && res.data && res.data.getEmailMergeContacts && res.data.getEmailMergeContacts.data){
          const filterdReceipents = res.data.getEmailMergeContacts.data;
          setReceipentOptions(filterdReceipents);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setReceipentOptions([]);
        }
      } catch (error) {
        console.error(error.message);
        setReceipentOptions([]);
        setIsLoading(false);
      }
    };
    
    // Call the function
    fetchContacts();
    
  }, []);

  const handleClose = () => {
    setMessage("");
    setError(false);
    setOpenEmailPopup(false);
  };

  const handleClear = () => {
    if(message && templateOptions.length === 0){
      formik.resetForm();
    }
    else{
      setMessage("");
      setError(false);
      formik.resetForm();
    }
  };

  // Modified EmailForm component to directly integrate with the formik instance
  const EmailFormWithFormik = () => {
    return (
      <div style={{ marginTop: "6px" }}>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center", justifyContent: "space-around" }}>
          <FormControl 
            fullWidth 
            variant="outlined" 
            error={formik.touched.recipientName && Boolean(formik.errors.recipientName)}
          >
            {/* <InputLabel id="recipient-label">Recipient</InputLabel> */}
            {/* <Select
              labelId="recipient-label"
              id="recipientName"
              name="recipientName"
              multiple
              value={formik.values.recipientName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              input={
                <OutlinedInput 
                  label="Recipient" 
                  endAdornment={
                    formik.values.recipientName.length > 0 && (
                      <IconButton
                        onClick={() => formik.setFieldValue("recipientName", [])}
                        edge="end"
                        size="small"
                      >
                        <ClearIcon />
                      </IconButton>
                    )
                  }
                />
              }
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 250,
                  },
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
              }}
              sx={{
                width: "300px",
                height: "48px",
                "& .MuiSelect-select": {
                  padding: "6px 14px",
                },
              }}
            >
              {receipentOptions.map((name) => (
                <MenuItem key={name.arcimedes_row_id} value={name.arcimedes_row_id}>
                  {`${name.first_name} ${name.last_name}`}
                </MenuItem>
              ))}
            </Select> */}
            {/* <Select
              labelId="recipient-label"
              id="recipientName"
              name="recipientName"
              multiple
              value={formik.values.recipientName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              input={
                <OutlinedInput
                  label="Recipient"
                  endAdornment={
                    formik.values.recipientName.length > 0 && (
                      <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                        <IconButton
                          onClick={() => formik.setFieldValue("recipientName", [])}
                          edge="end"
                          size="small"
                        >
                          <ClearIcon />
                        </IconButton>
                      </Box>
                    )
                  }
                />
              }
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 250,
                  },
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
              }}
              sx={{
                width: "300px",
                height: "48px",
                "& .MuiSelect-select": {
                  padding: "6px 14px",
                },
              }}
            >
              {receipentOptions.map((item) => (
                // <MenuItem key={item.recipient_id} value={item.recipient_id}>
                //   {item.name}
                // </MenuItem>
                <MenuItem
                key={`${item.recipient_id}-${formik.values.recipientName.length}`}
                value={item.recipient_id}
                sx={{
                  display: "block !important",
                  width: "100% !important",
                  fontSize: "14px !important",
                  color: "#333 !important",
                  padding: "8px 16px !important", // Standard MUI padding
                  margin: "4px 0 !important", // Optional for better spacing between items
                  "&:hover": {
                    backgroundColor: "#f0f0f0 !important",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#90C54B !important",
                    color: "#fff !important",
                  },
                }}
              >
                {item.name}
              </MenuItem>
              ))}
            </Select> */}
            <Autocomplete
              className="multiple"
              multiple
              fullWidth
              options={receipentOptions}
              getOptionLabel={(option) => option.name}
              value={receipentOptions.filter((item) =>
                formik.values.recipientName.includes(item.recipient_id)
              )}
              id="recipientName"
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Recipient" // ✅ Using placeholder instead of label
                  variant="outlined"
                  InputLabelProps={{ shrink: true }} // ✅ Prevents overlap issues
                  onBlur={formik.handleBlur}
                />
              )}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip
                    key={index}
                    {...getTagProps({ index })}
                    deleteIcon={
                      <div
                        className="chip-remove-icon"
                        dangerouslySetInnerHTML={{ __html: removeCircle }}
                      />
                    }
                    label={option.name} // ✅ Fix: Properly display selected value
                  />
                ))
              }
              onChange={(_, newValue) => {
                formik.setFieldValue(
                  "recipientName",
                  newValue.map((item) => item.recipient_id)
                );
              }}
              // popupIcon={
              //   <div className="dropdown-icon arrow" dangerouslySetInnerHTML={{ __html: arrow }} />
              // }
              popupIcon={<ArrowDropDownIcon />}
              // closeIcon={
              //   <div className="dropdown-icon" dangerouslySetInnerHTML={{ __html: close }} />
              // }
            />
        {/* {formik.touched.recipientName && formik.errors.recipientName && (
              <FormHelperText error>{formik.errors.recipientName}</FormHelperText>
            )} */}
          </FormControl>

          <FormControl 
            fullWidth 
            variant="outlined"
            error={formik.touched.templateName && Boolean(formik.errors.templateName)}
          >
            {/* <InputLabel id="template-label">Template</InputLabel> */}
            {/* <Select
              labelId="template-label"
              id="templateName"
              name="templateName"
              value={formik.values.templateName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              input={
                <OutlinedInput 
                  label="Template"
                  endAdornment={
                    formik.values.templateName.length > 0 && (
                      // <IconButton
                      //   onClick={() => formik.setFieldValue("templateName", "")}
                      //   edge="end"
                      //   size="small"
                      // >
                      //   <ClearIcon />
                      // </IconButton>
                      <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                        <IconButton
                          onClick={() => formik.setFieldValue("templateName", "")}
                          edge="end"
                          size="small"
                        >
                          <ClearIcon />
                        </IconButton>
                      </Box>
                    )
                  }
                />
              }
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 250,
                  },
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
              }}
              sx={{
                width: "300px",
                height: "48px",
                "& .MuiSelect-select": {
                  padding: "6px 14px",
                },
              }}
            >
              {templateOptions.map((option, index) => (
                <MenuItem key={index} value={option.template_name}
                sx={{
                  display: "block !important",
                  width: "100% !important",
                  fontSize: "14px !important",
                  color: "#333 !important",
                  padding: "8px 16px !important", // Standard MUI padding
                  margin: "4px 0 !important", // Optional for better spacing between items
                  "&:hover": {
                    backgroundColor: "#f0f0f0 !important",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#90C54B !important",
                    color: "#fff !important",
                  },
                }}>
                  {option.template_name}
                </MenuItem>
              ))}
            </Select> */}
            <Autocomplete
            className=''
              fullWidth
              options={templateOptions}
              getOptionLabel={(option) => option.template_name}
              value={templateOptions.find((item) => item.template_name === formik.values.templateName) || null} // ✅ Ensure single value
              id="templateName"
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Template"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  onBlur={formik.handleBlur}
                />
              )}
              onChange={(_, newValue) => {
                formik.setFieldValue("templateName", newValue ? newValue.template_name : "");
              }}
              popupIcon={<ArrowDropDownIcon />}
              // popupIcon={
              //   <div className="dropdown-icon arrow" dangerouslySetInnerHTML={{ __html: arrow }} />
              // }
              // closeIcon={
              //   <div className="dropdown-icon" dangerouslySetInnerHTML={{ __html: close }} />
              // }
            />
            {/* {formik.touched.templateName && formik.errors.templateName && (
              <FormHelperText error>{formik.errors.templateName}</FormHelperText>
            )} */}
          </FormControl>
        </Box>
      </div>
    );
  };

  return (
    <React.Fragment>
       {
            isLoading ? 
            <ReusableSpinner />: ""
          }
      <Dialog
        open={openEmailPopup}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle
            style={{
              cursor: "move",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingRight: "1rem",
            }}
            id="draggable-dialog-title"
          >
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
              <h5 style={{ fontSize: "1.3rem", margin: 0 }}>Email</h5>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <div style={{marginTop:"-10px"}} className="line" />

          <DialogContent>
            <EmailFormWithFormik />
          </DialogContent>
          {message && (
            <div className="flex justify-center items-center py-2 "  style={{textAlign:"center"}}>
              <Alert severity={templateOptions.length === 0 ? "info" : error ? "error" : "success"}>{message}</Alert>
            </div>
          )}
          <DialogActions>
            <Button  className="button-new positive" 
            type="button" 
            //autoFocus 
            onClick={handleClear} 
            disabled={formik.values.recipientName.length === 0 && !formik.values.templateName}
            >
              Clear
              </Button>
            <Button 
              type="submit"
              className="button-new positive"
              disabled={!formik.isValid || formik.values.recipientName.length === 0 || !formik.values.templateName}
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}